export default __webpack_public_path__ + "static/alej-e528c170a1ce7792ddb201dfe3e641f3.png";